const EarthquakeIntensity = require('./earthquake/EarthquakeIntensity')
const ChemicalLeak = require('./chemical/ChemicalLeak')
const ChemicalExplode = require('./chemical/ChemicalExplode')
const ChemicalFire = require('./chemical/ChemicalFire')

/**
 * @ignore
 * @namespace
 * @memberOf G
 * @alias G.model
 * @description 模型展示包
 */
const components = {
    EarthquakeIntensity,
    ChemicalLeak,
    ChemicalExplode,
    ChemicalFire
};
module.exports = components;